import $ from 'jquery';
import {Collapse, Modal} from 'bootstrap';
import 'jquery-parallax.js';
import {OverlayScrollbars} from "overlayscrollbars";
import {Fancybox} from '@fancyapps/ui';
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import 'regenerator-runtime/runtime';

// eslint-disable-next-line no-undef
const object = gralObject;

$('.header-nav__wrapper .menu-item-has-children > a').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    const currentList = $(this).closest('li');
    const currentMenu = currentList.find('.sub-menu');
    const currentIcon = $(this).find('i');

    currentList.toggleClass('submenu-active');
    currentMenu.slideToggle('300');
    currentIcon.toggleClass('submenu-icon--active');
    if (screen.width < 720) {
        $('.header-nav__closer').css('visibility', 'hidden')
    }
});

$('.header-nav-toggle').on('click', function () {
    $('.header-nav').toggleClass('header-nav--active');

    $('body').toggleClass('menu-active');

    $(document).trigger('gralModal', {
        open: $('.header-nav').hasClass('header-nav--active'),
    });
});

$('.header-nav__overlay-col').on('click', function (e) {
    if (e.target !== e.currentTarget) return;
    $('.header-nav').toggleClass('header-nav--active');

    $('body').toggleClass('menu-active');

    $(document).trigger('gralModal', {
        open: $('.header-nav').hasClass('header-nav--active'),
    });
});

$(document).on('click', '.menu-item-panel__closer', function () {
    $(this).parents('.menu-item-panel').removeClass('menu-item-panel--active');

    const allPanelLinks = $('.menu-item-has-panel');

    allPanelLinks.removeClass('menu-item-has-panel--active');
    allPanelLinks.find('i').removeClass('submenu-icon--active');
    if (screen.width < 720) {
        $('.header-nav__closer').css('visibility', 'visible')
    }
});

$('.menu-item-has-panel').on('click', function (e) {
    e.stopPropagation();
    e.preventDefault();
    e.stopImmediatePropagation();

    const thisButton = $(this);
    const otherButtons = $('.menu-item-has-panel').not(thisButton);

    otherButtons.removeClass('menu-item-has-panel--active');
    thisButton.toggleClass('menu-item-has-panel--active');

    otherButtons.find('i').removeClass('submenu-icon--active');
    thisButton.find('i').toggleClass('submenu-icon--active');
    if (screen.width < 720) {
        $('.header-nav__closer').css('visibility', 'hidden')
    }

    const target = $(this).attr('data-panel');
    $('.menu-item-panel').not(target).removeClass('menu-item-panel--active');
    $(target).toggleClass('menu-item-panel--active');
});

const setMenuPanelPos = () => {
    const panels = $('.menu-item-panel');

    if (window.matchMedia('(min-width: 992px)').matches) {
        panels.appendTo($('.header-nav__overlay-col'));
    } else {
        panels.appendTo($('.header-nav__menu-col-inner'));
    }
};

$(window).on('resize', setMenuPanelPos).trigger('resize');

const jsContainer = () => {
    if ($('.js-container').length) {
        const bodyWidth = $('body').outerWidth();
        $('.js-container').css({
            width: bodyWidth,
            marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
        });
    }
};

$(window).on('resize', jsContainer).trigger('resize');

$('.select-redirection').on('change', function () {
    window.location.href = $(this).val();
});

const header = $('.site-header');
const slider = $('.home-slider');

if (slider.length) {
    $(window).on('scroll', function () {
        if (!window.matchMedia('(min-width: 768px)').matches) {
            return;
        }

        const pos = $(window).scrollTop();
        const sliderHeight = slider.height();
        const headerHeight = header.height();

        if (pos > sliderHeight - headerHeight) {
            header.addClass('site-header--dark');
        } else {
            header.removeClass('site-header--dark');
        }
    });
}

$(window).on('scroll', function () {
    const pos = $(window).scrollTop();
    const scrollTopButton = $('.scroll-top');

    if (pos > 200) {
        scrollTopButton.addClass('scroll-top--active');
    } else {
        scrollTopButton.removeClass('scroll-top--active');
    }
});

$('.scroll-top').click(function () {
    window.scrollTo({top: 0, behavior: 'smooth'});
});

let recipeCount = 1;
$('.menu-item-panel__more').on('click', function () {
    const $this = $(this);
    const container = $this.parent().parent().find('.row');
    const loader = $this.parent().find('.gral-loader');

    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: {
            nonce: object.nonce,
            action: 'gral_menu_recipes_categories',
            count: recipeCount,
        },
        beforeSend: () => {
            loader.show();
        },
        success: (res) => {
            if (res.success) {
                container.append(res.data.result);
                recipeCount++;
            } else {
                $this.replaceWith(`<span class="menu-item-panel__more--error">${res.data.message}</span>`);
            }
        },
        complete: () => {
            loader.hide();
        },
    });
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.gral-scrollbar').forEach((e) => {
        OverlayScrollbars(e, {
            className: 'os-theme-thin-dark',
        });
    })
});

$('.wp-block-gallery').each(function (i) {
    const $this = $(this);
    $this.attr('data-block-gallery', i);
    const items = $(`[data-block-gallery=${i}]`).find('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]');
    items.attr('data-fancybox', `block-gallery-${i}`);

    $this.find('a').each(function () {
        $(this).attr('data-caption', $(this).next().text());
    });

    Fancybox.bind(`[data-block-gallery=${i}]`);
});


//Usefull for anchors to another page to work on Chrome
jQuery(document).ready(function () {
    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    if (window.location.hash && isChrome) {
        setTimeout(function () {
            var hash = window.location.hash;
            window.location.hash = "";
            window.location.hash = hash;
        }, 300);
    }
});
